import { render, staticRenderFns } from "./continue-student-page.html?vue&type=template&id=c830fc2e&"
import script from "./continue-student-page.ts?vue&type=script&lang=ts&"
export * from "./continue-student-page.ts?vue&type=script&lang=ts&"
import style0 from "./continue-student-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports